import { defineMailTemplate } from '@adornis/mails/db/mail-template-definition.js';
import {
  getMentorAndMenteeMailVariableData,
  getMentorAndMenteeMailVariables,
  MailTemplateType,
} from '../entities/mail-templates.js';

export function registerFreeFormMentee() {
  return defineMailTemplate(MailTemplateType.FREE_FORM_MENTEE, {
    getMailData: getMentorAndMenteeMailVariableData,
    defaultTemplate: {
      subject: ``,
      content: ``,
      footer: '',
    },
    variables: getMentorAndMenteeMailVariables().filter(varName => varName.startsWith('mentee.')),
    attachments: [],
    displayName: 'Freie Mail: Mentee',
    editorHint: () => 'Diese Mail kann frei verwendet werden',
  });
}
